import { useSelector } from 'react-redux';
import FJMobileTextToImagePreset from './FJMobileTextToImagePreset';

const FJMobileTextToImagePresetContainer = () => {
    const creationList = useSelector(state => state.common.creationList);
    if (creationList?.length) return null;
    return <FJMobileTextToImagePreset creationList={creationList} />;
};
export default FJMobileTextToImagePresetContainer;
